import { FieldTypes } from 'ui-forms-components/constants/FieldTypeMapping';
export const Values = {
  [FieldTypes.NUMBER]: '100',
  [FieldTypes.TEXT]: 'editor.preview.knownValue',
  [FieldTypes.TEXTAREA]: 'editor.preview.knownValue'
};